import React, { Component } from 'react';
import { GeckoModal, GECKO_CONSTS, GeckoModalService } from '../../../ui';
import GeckoLocation from 'services/gecko-location';

class SftpSetupModal extends Component {
  fields = [
    {
      key: 'text',
      width: '100%',
      type: GECKO_CONSTS.FIELD_TYPE_DISPLAY,
      render: () => {
        return <div>{this.props.text}</div>;
      },
    },
  ];

  footerButtons = [
    {
      name: 'Cancel',
      type: 'default',
      icon: 'fas fa-times',
      handler: () => {
        return new GeckoModalService().close();
      },
    },
    {
      name: 'Setup Recurring Export',
      type: 'success',
      icon: 'fas fa-sync',
      handler: () => {
        new GeckoModalService().close();
        return GeckoLocation.goTo(`/settings/exports/new`);
      },
    },
  ];

  render() {
    return (
      <GeckoModal
        name={this.props.headerText}
        fields={this.fields}
        btns={this.footerButtons}
      />
    );
  }
}

export default SftpSetupModal;
